import {
    noConversationsSelected,
    oneConversationSelected,
    someConversationsSelected,
    everythingSelectedTab,
} from './getItemsOrConversationsSelectedText.locstring.json';
import { everythingSelected } from 'owa-locstrings/lib/strings/everythingselected.locstring.json';
import { everythingSelectedOther } from 'owa-locstrings/lib/strings/everythingselectedother.locstring.json';
import { everythingSelectedFocused } from 'owa-locstrings/lib/strings/everythingselectedfocused.locstring.json';
import { everythingSelectedSearch } from 'owa-locstrings/lib/strings/everythingselectedsearch.locstring.json';
import {
    noItemsSelected,
    oneItemSelected,
    someItemsSelected,
} from 'owa-locstrings/lib/strings/someitemsselected.locstring.json';
import loc, { format } from 'owa-localize';
import listViewStore from '../store/Store';
import getIsEverythingSelectedInTable from './getIsEverythingSelectedInTable';
import isItemPartOperation from './isItemPartOperation';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import getFocusedFilterForTable from '../utils/getFocusedFilterForTable';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import {
    getInboxClassificationFilterForTable,
    TableQueryType,
    MailFolderTableQuery,
} from 'owa-mail-list-store';
import getInboxPlusPivotDisplayProperties from 'owa-mail-inbox-plus-store/lib/selectors/getInboxPlusPivotDisplayProperties';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';
import folderStore, { getEffectiveFolderDisplayName } from 'owa-folders';

export default function getItemsOrConversationsSelectedText(tableViewId: string): string {
    const tableView = listViewStore.tableViews.get(tableViewId);
    const focusedFilter = getFocusedFilterForTable(tableView);
    const inboxClassificationFilter = getInboxClassificationFilterForTable(tableViewId);

    // User is in select all mode
    if (getIsEverythingSelectedInTable(tableView)) {
        // Some items are deselected, return total item count - number of deselected items
        if (tableView.virutalSelectAllExclusionList.length > 0) {
            return format(
                loc(someItemsSelected),
                tableView.totalRowsInView - tableView.virutalSelectAllExclusionList.length
            );
            // User is in select all mode in focused/other table
        } else if (
            isInboxPlusEnabled() &&
            folderNameToId('inbox') === tableView.tableQuery.folderId
        ) {
            const displayProperties = getInboxPlusPivotDisplayProperties(inboxClassificationFilter);
            return format(loc(everythingSelectedTab), displayProperties.displayText);
        } else if (focusedFilter !== FocusedViewFilter.None) {
            return focusedFilter === FocusedViewFilter.Focused
                ? loc(everythingSelectedFocused)
                : loc(everythingSelectedOther);
            // User is in search results
        } else if (tableView.tableQuery.type == TableQueryType.Search) {
            return loc(everythingSelectedSearch);
            // User is in favorited category
        } else if ((tableView.tableQuery as MailFolderTableQuery).viewFilter === 'UserCategory') {
            return format(
                loc(everythingSelected),
                (tableView.tableQuery as MailFolderTableQuery).categoryName
            );
        } else {
            // Everything in folder or favorited persona is selected
            const folder = folderStore.folderTable.get(tableView.tableQuery.folderId);
            return format(loc(everythingSelected), getEffectiveFolderDisplayName(folder));
        }
    } else {
        // User has selected a specific number of items or item parts
        const numSelections = isItemPartOperation()
            ? listViewStore.expandedConversationViewState.selectedNodeIds.length
            : tableView.selectedRowKeys.size;
        if (
            tableView.tableQuery.listViewType == ReactListViewType.Message ||
            isItemPartOperation()
        ) {
            // Designate string for items
            if (numSelections === 0) {
                return loc(noItemsSelected);
            } else if (numSelections === 1) {
                return loc(oneItemSelected);
            }
            return format(loc(someItemsSelected), numSelections);
        }
        // Designate string for conversations
        if (numSelections === 0) {
            return loc(noConversationsSelected);
        } else if (numSelections === 1) {
            return loc(oneConversationSelected);
        }
        return format(loc(someConversationsSelected), numSelections);
    }
}
